import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {SubjektasApi} from "../../api/subjektas.api";
import {KlasifikatoriusApi} from "../../api/klasifikatorius.api";
import {TranslateService} from "@ngx-translate/core";
import {AtaskPerziuraService} from "../../service/atask-perziura.service";
import {SharedDataService} from "../../service/shared-data.service";
import {GiiAtaskaitaApi} from '../../api/gii-ataskaita.api';
import {Router} from '@angular/router';
import {RegPerziuraService} from '../../service/reg-perziura.service';
import {GiiRegistracijaApi} from '../../api/gii-registracija.api';
import {GiiAtaskVertinimasApi} from '../../api/gii-atask-vertinimas.api';
import {AppNotificationService} from '../../service/app-notification.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AsmenysApi} from '../../api/asmenys.api';
import {GiiAtaskaitaService} from '../../service/gii-ataskaita.service';
import {debounceTime, distinctUntilChanged, forkJoin, Subject, switchMap, take, takeUntil} from 'rxjs';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import {PdfExportService} from "../../service/pdf-export.service";
import {PDFExportComponent} from "@progress/kendo-angular-pdf-export";
import {LanguageService} from "../../service/language.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {RegKoregavimasEnumType} from "../../enums/reg-koregavimas-enum";
import {AtaskKoregavimasEnum, AtaskKoregavimasEnumType} from "../../enums/atask-koregavimas-enum";

@Component({
  selector: 'app-atask-perziura-pilna',
  templateUrl: './atask-perziura-pilna.component.html',
  styleUrls: ['./atask-perziura-pilna.component.css']
})
export class AtaskPerziuraPilnaComponent implements OnInit {
  @ViewChild('pdfExport') pdfExport!: PDFExportComponent;
  @ViewChild('asmenysList') asmenysList: DropDownListComponent | undefined;
  header = '';
  klasifikatoriusList: KlasifikatoriusApi[] = [];
  giiAtaskaitaApi = new GiiAtaskaitaApi();
  giiRegistracijaApi: GiiRegistracijaApi = new GiiRegistracijaApi();
  isRowSelected = false;
  selectedRow: any = null;
  busenuIstorija: any[] = [];
  giiAtaskVertinimasList: any[] = [];
  subjektasApi!: SubjektasApi;
  tikrinimoDuomenys: GiiAtaskVertinimasApi = new GiiAtaskVertinimasApi();
  atmestiDuomenys: GiiAtaskVertinimasApi = new GiiAtaskVertinimasApi();
  loadPdf = false;
  isPrinting = false;
  rowData: any;
  public ataskKurimoGroup: FormGroup;

  public pradetiTikrinimaConfirmOpened = false;
  public patikrintaConfirmOpened = false;
  public tikrinimoDuomenysOpened = false;
  public atmestiOpened = false;
  public atmestiConfirmOpened = false;
  public priskirtiAsmeniOpened = false;

  public asmenys: AsmenysApi[] = [];
  public filter: string = '';
  public pasirinktasAsmuo: any;
  private destroy$ = new Subject<void>();
  private filterSubject = new Subject<string>();

  constructor(private regPerziuraService: RegPerziuraService,
              private router: Router,
              private perziuraService: AtaskPerziuraService,
              private translate: TranslateService,
              public sharedDataService: SharedDataService,
              private appNofiticationService: AppNotificationService,
              public giiAtaskaitaService: GiiAtaskaitaService,
              private pdfService: PdfExportService,
              private languageService: LanguageService,
              private ataskPerziuraService: AtaskPerziuraService) {
    this.setupFilter();
    this.ataskKurimoGroup = new FormGroup({
      priezastys: new FormControl(this.atmestiDuomenys.atmetimoPriezastis, [Validators.required]),
      terminas: new FormControl(this.atmestiDuomenys.tikslinimoTerminas, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.ataskPerziuraService.ataskPerziura$
      .pipe(
        distinctUntilChanged((a, b) => a?.selectedId === b?.selectedId),
        takeUntil(this.destroy$)
      )
      .subscribe(perziura => {
        if (perziura?.selectedId) {
          this.isRowSelected = false;
          this.rowData = perziura;
          this.updateHeader();
          this.loadData(perziura);
        }
      });

    this.sharedDataService.getklasifikatoriusApiSubject()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: KlasifikatoriusApi[]) => {
        this.klasifikatoriusList = data;
      });

    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateHeader());
  }

  ngOnDestroy(): void {
    this.destroy$.next(void 0);
    this.destroy$.complete();
  }

  private loadData(rowData: any): void {
    this.sharedDataService.setIsLoading(true);
    this.filterSubject.next(this.filter);
    forkJoin([
      this.regPerziuraService.fetchGiiRegistracijaById(rowData.regId),
      this.perziuraService.fetchGiiAtaskaitaById(rowData.selectedId)
    ]).subscribe(([registracija, ataskaita]) => {
      this.giiRegistracijaApi = registracija;
      this.giiAtaskaitaApi = ataskaita;
      this.atmestiDuomenys.tikslinimoTerminas = new Date(ataskaita.tikslinimoTerminas);
      this.busenuIstorija = ataskaita.giiAtaskKoregavimasList;
      this.giiAtaskVertinimasList = ataskaita.giiAtaskVertinimasList;
      this.sharedDataService.setIsLoading(false);
    });
  }

  public async printGrid(): Promise<void> {
    await this.pdfService.print(this, () => this.pdfExport);
  }

  translateClassifierLabel(id: string): string {
    for (const klasifikatorius of this.klasifikatoriusList) {
      const klasifikatoriausReiksme = klasifikatorius.klasifikatoriausReiksmeApiList?.find(y => y.id === Number(id));

      if (klasifikatoriausReiksme) {
        return this.languageService.translatePavadinimas(klasifikatoriausReiksme.pavadinimas);
      }
    }
    return '';
  }

  onRowSelect(selectedItem: any): void {
    this.selectedRow = selectedItem;
    this.isRowSelected = true;
  }

  onTikrintinaClicked(): void {
    let ataskVertinimasApi = new GiiAtaskVertinimasApi();
    ataskVertinimasApi.ataskaitaId = this.giiAtaskaitaApi.id;
    ataskVertinimasApi.vertinimoVeiksmas = 'TIKRINTINA';
    this.sukurtiAtaskaitosVertinima(ataskVertinimasApi);
  }

  onNeTikrintinaClicked(): void {
    let ataskVertinimasApi = new GiiAtaskVertinimasApi();
    ataskVertinimasApi.ataskaitaId = this.giiAtaskaitaApi.id;
    ataskVertinimasApi.vertinimoVeiksmas = 'NETIKRINTINA';
    this.sukurtiAtaskaitosVertinima(ataskVertinimasApi);
  }

  onpradetiTikrinimaClicked(): void {
    this.pradetiTikrinimaConfirmcOpen();
  }

  onpradetiTikrinimaConfirmClicked(): void {
    let ataskVertinimasApi = new GiiAtaskVertinimasApi();
    ataskVertinimasApi.ataskaitaId = this.giiAtaskaitaApi.id;
    ataskVertinimasApi.vertinimoVeiksmas = 'PRADETI_TIKRINIMA';
    this.sukurtiAtaskaitosVertinima(ataskVertinimasApi);
    this.pradetiTikrinimaConfirmclose();
  }

  onTikrinimoDuomenysClicked(): void {
    this.tikrinimoDuomenysConfirmOpen();
  }

  onTikrinimoDuomenysConfirmClicked(): void {
    this.tikrinimoDuomenys.ataskaitaId = this.giiAtaskaitaApi.id;
    this.tikrinimoDuomenys.vertinimoVeiksmas = 'TIKRINIMO_DUOMENYS';
    this.sukurtiAtaskaitosVertinima(this.tikrinimoDuomenys);
    this.tikrinimoDuomenys = new GiiAtaskVertinimasApi();
    this.tikrinimoDuomenysConfirmClose();
  }

  onPatikrintaClicked(): void {
    this.patikrintaConfirmOpen();
  }

  onPatikrintaConfirmClicked(): void {
    let ataskVertinimasApi = new GiiAtaskVertinimasApi();
    ataskVertinimasApi.ataskaitaId = this.giiAtaskaitaApi.id;
    ataskVertinimasApi.vertinimoVeiksmas = 'PATIKRINTA';
    this.sukurtiAtaskaitosVertinima(ataskVertinimasApi);
    this.patikrintaConfirmClose();
  }

  onAtmestiClicked(): void {
    this.atmestiConfirmOpen()
  }

  onAtmestiConfirmClicked(): void {
    if (!this.ataskKurimoGroup.valid) {
      this.ataskKurimoGroup.markAllAsTouched();
      return;
    }
    this.atmestiConfirmClose();
    this.atmestiDialogConfirmOpen();
  }

  onAtmestiDialogConfirmClicked(): void {
    this.atmestiDuomenys.ataskaitaId = this.giiAtaskaitaApi.id;
    this.atmestiDuomenys.vertinimoVeiksmas = 'ATMESTI';
    this.sukurtiAtaskaitosVertinima(this.atmestiDuomenys);
    this.atmestiDuomenys = new GiiAtaskVertinimasApi();
    this.atmestiDialogConfirmClose();
  }

  onPriskirtiClicked(): void {
    this.priskirtiAsmeniOpen();
  }

  sukurtiAtaskaitosVertinima(ataskVertinimasApi: GiiAtaskVertinimasApi): void {
    this.perziuraService.sukurtiAtaskaitosVertinima(ataskVertinimasApi).subscribe(giiAtaskaita => {
      this.giiAtaskaitaApi = giiAtaskaita;
      this.busenuIstorija = this.giiAtaskaitaApi.giiAtaskKoregavimasList;
      this.giiAtaskVertinimasList = this.giiAtaskaitaApi.giiAtaskVertinimasList;
    }, errorResponse  => {
      const errorMessage = errorResponse.error;
      this.appNofiticationService.showNotification('error', errorMessage);
    });
  }

  priskirtiAsmeni(ataskVertinimasApi: GiiAtaskVertinimasApi): void {
    this.perziuraService.priskirtiAsmeni(ataskVertinimasApi).subscribe(giiAtaskaita => {
      this.giiAtaskaitaApi = giiAtaskaita;
      this.busenuIstorija = this.giiAtaskaitaApi.giiAtaskKoregavimasList;
      this.giiAtaskVertinimasList = this.giiAtaskaitaApi.giiAtaskVertinimasList;
    }, errorResponse  => {
      const errorMessage = errorResponse.error;
      this.appNofiticationService.showNotification('error', errorMessage);
    });
  }

  enableTikrintinaButton(): boolean {
    return this.giiAtaskaitaApi.busena == 'PRIIMTA' && this.giiAtaskaitaApi.vidineBusena == 'NERA';
  }

  enableNeTikrintinaButton(): boolean {
    return this.giiAtaskaitaApi.busena == 'PRIIMTA' && this.giiAtaskaitaApi.vidineBusena == 'TIKRINTINA';
  }

  enablePradetiTikrinimaButton(): boolean {
    return this.giiAtaskaitaApi.busena == 'PRIIMTA' && (this.giiAtaskaitaApi.vidineBusena == 'TIKRINTINA' || this.giiAtaskaitaApi.vidineBusena == 'PATIKRINTA');
  }

  enableTikrinimoDuomenysButton(): boolean {
    return this.giiAtaskaitaApi.busena == 'PRIIMTA' && this.giiAtaskaitaApi.vidineBusena == 'TIKRINAMA';
  }

  enablePatikrintaButton(): boolean {
    return this.giiAtaskaitaApi.busena == 'PRIIMTA' && this.giiAtaskaitaApi.vidineBusena == 'TIKRINAMA';
  }

  enableAtmestiButton(): boolean {
    return this.giiAtaskaitaApi.busena == 'PRIIMTA' && this.giiAtaskaitaApi.vidineBusena == 'TIKRINAMA';
  }

  public pradetiTikrinimaConfirmclose(): void {
    this.pradetiTikrinimaConfirmOpened = false;
  }

  public pradetiTikrinimaConfirmcOpen(): void {
    this.pradetiTikrinimaConfirmOpened = true;
  }

  public priskirtiAsmeniClose(): void {
    this.priskirtiAsmeniOpened = false;
  }

  public priskirtiAsmeniOpen(): void {
    this.priskirtiAsmeniOpened = true;
  }

  public tikrinimoDuomenysConfirmClose(): void {
    this.tikrinimoDuomenysOpened = false;
  }

  public tikrinimoDuomenysConfirmOpen(): void {
    this.tikrinimoDuomenysOpened = true;
  }

  public atmestiConfirmClose(): void {
    this.atmestiOpened = false;
  }

  public atmestiConfirmOpen(): void {
    this.atmestiOpened = true;
  }

  public patikrintaConfirmClose(): void {
    this.patikrintaConfirmOpened = false;
  }

  public patikrintaConfirmOpen(): void {
    this.patikrintaConfirmOpened = true;
  }

  public atmestiDialogConfirmClose(): void {
    this.atmestiConfirmOpened = false;
  }

  public atmestiDialogConfirmOpen(): void {
    this.atmestiConfirmOpened = true;
  }

  onPriskirtiConfirmClicked(): void {
    let ataskVertinimasApi = new GiiAtaskVertinimasApi();
    ataskVertinimasApi.vertintojas = this.pasirinktasAsmuo;
    ataskVertinimasApi.ataskaitaId = this.giiAtaskaitaApi.id;
    this.priskirtiAsmeni(ataskVertinimasApi);
    this.priskirtiAsmeniClose();
  }

  public onFilterChange(filter: string): void {
    this.filter = filter
    this.filterSubject.next(filter);
  }

  private setupFilter(): void {
    this.filterSubject
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(filter => this.giiAtaskaitaService.fetchAsmenys(this.filter))
      )
      .subscribe((data: any) => {
        this.asmenys = data.content;
      });
  }

  private updateHeader(): void {
    const key = 'label.srautas.daugiskaita.' + this.rowData.srautoKodas;
    this.header = this.translate.instant(key) + ' ' +
      this.translate.instant('apskaita.kurimas.title') + ' ' +
      this.rowData.ataskLaikotarpis + ' ' +
      this.translate.instant('label.metus');
  }

  isEnumValue(value: string): boolean {
    return AtaskKoregavimasEnum.includes(value as AtaskKoregavimasEnumType);
  }
}
